import api from '@/http/api'
import { useQuery } from '@tanstack/react-query'

export interface OrderTrackingOrder {
  order_id: number
  order_ref: string
  customer_id: number
  job_title: string
}

export interface OrderTracking {
  id: number
  carrier: string
  tracking_id: string
  status: string
  /** 'YYYY-MM-DD', or null when not recorded. */
  shipping_date: string | null
  created_at: string
  orders: OrderTrackingOrder[]
}

const fetchOrderTracking = (): Promise<OrderTracking[]> =>
  api.get('/admin/order-tracking').then(r => r.data.data)

export const useOrderTracking = () => {
  return useQuery<OrderTracking[]>({
    queryKey: ['order-tracking'],
    queryFn: fetchOrderTracking,
  })
}
